export default "__VITE_ASSET__C3I5HUqJ__"